import styled from 'styled-components';

export const Container = styled.div`
  padding: 120px 2rem 5rem;
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

export const PageTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  
  span {
    color: #2A4FC9;
  }
`;

export const PageDescription = styled.p`
  max-width: 700px;
  margin: 0 auto;
  color: #909090;
`;

export const SectionTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  
  span {
    color: #2A4FC9;
  }
`;
